module.exports = __webpack_public_path__ + "media/4.cb984f59.wav";